<template>
  <div id="app">
  
    
    <router-view></router-view>

  </div>
</template>

<script>
//import GertrudeForm from './components/GertrudeForm.vue'

export default {
  name: 'Gertrude',
  created () {
          document.title = "Gertrude - Digitale Manuscriptvergelijking";
  },
  components: {
    //GertrudeForm
  }
}
</script>

<style>
body {
    height: 100%;
    background-color:#000a3f;
}

h1{
  margin-top: 0.2  em;
  font-size: 5.8em;
}

h2{
font-size: 1.6em;
}

#app {
  
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  margin-top:1%;
 
}



</style>

